import React from 'react';
// import { Container } from 'react-bootstrap';
// import juicebox from jbcore/juicebox;
// import Lightbox from './Lightbox';
// import S3Lightbox from './S3Lightbox';
import Lightbox from './Lightbox';

const Street = () => {
    
    return ( 
        <Lightbox searchKey='street'></Lightbox>
     );
}
 
export default Street;